import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class QualityMenuController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    
    // Types to be determined
    readonly beginDate;
    readonly endDate;
    readonly group;
    readonly groupGuid;

    static $inject = [];

}

export const wtQualityMenu: ComponentDefinition = {
    componentId: 'wtQualityMenu',
    controller: QualityMenuController,
    template: require('./qualityMenu.component.html'),
    controllerAs: 'vm',
    bindings: {
        beginDate: '<',
        endDate: '<',
        group: '<',
        groupGuid: '<'
    }
};
